import { motion } from "motion/react"
import { FaCheckCircle } from "react-icons/fa";
import { MdDangerous } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const PricingCard = ({ variants, pack }) => {

  const { data } = pack

  const navigate = useNavigate()


  return (
    <motion.div transition={{
      type: 'spring',
      bounce: 0.6, duration: 1, dumping: 1,
    }} variants={variants} className=' h-full w-full rounded bg-gradient-to-tl from-neutral-900 to-transparent border-yellow-500/10 border shadow-xs p-5 space-y-5'>
      <div className=" space-y-5 h-max">

        <div className="flex flex-col justify-start  items-center gap-5  ">

          <h1 className='text-neutral-200 text-2xl font-bold text-center font-logo'>{pack.title}</h1>
          <p className='text-neutral-300 text-xs text-center'>{pack.description}</p>
        </div>

        <div className='text-center'>
          {typeof (pack.price) == "number" ? <p className='text-6xl text-orange-500 font-bold font-logo'> {pack.price}$   </p> : <p className='text-6xl  text-orange-500 font-bold'> N/A   </p>}
        </div>
        <p className='text-neutral-300 text-sm text-center'>Per Day</p>
        {typeof (pack.price) == "number" ? <button onClick={() => navigate(`./subscribe?id=${pack.id}&package=${pack.title}`)} className='btn-primary w-full'>GET STARTED</button> : <button className='btn-primary w-full'>Contact Us</button>}

      </div>
      <p className='border-b border-neutral-800 w-full'></p>


      <div className='grid gap-3'>

        {
          data?.map((item, i) => <div  key={i} className=' flex gap-2 items-center '>
            {item.isActive ? <FaCheckCircle className='text-green-400 text-lg' /> : <MdDangerous className='text-red-500 text-xl' />}
            <p className='text-neutral-300 text-xs text-left'>{item.title}</p>
          </div>)
        }

      </div>
      <p className='border-b border-neutral-800 w-full'></p>
    </motion.div>

  )

}

export default PricingCard